import { errorMessage } from '@features/applicationQuestions';
import { companiesPlansList } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { enterpriseUpdateCompaniesPlan } from '../api/constants';
import { totalAggregateKey } from '../constants';

type useUpateCompanyPlanProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};
const useUpateCompanyPlan = ({ setErrorText }: useUpateCompanyPlanProps) => {
  const client = useQueryClient();
  const { mutate: updatePlan, isLoading: isUpdatingPlan } = useMutation({
    mutationFn: (variables: { company_id: number; plan_type: number; update: string }) => {
      return axiosInstance
        .post(enterpriseUpdateCompaniesPlan, variables)
        .then((res) => res.data);
    },
    onSuccess: (res) => {
      if (res.status == 200) {
        client.invalidateQueries([totalAggregateKey]);
        client.invalidateQueries([companiesPlansList]);
      } else {
        setErrorText(res?.message || errorMessage)
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });
  return { updatePlan, isUpdatingPlan };
};

export default useUpateCompanyPlan;
